import React, { type ReactNode } from 'react';
import { Box } from '@atlaskit/primitives/compiled/box';
import { cssMap } from '@atlaskit/css';
import Grid from '@atlaskit/page/grid';
import { GridColumn } from '@atlaskit/page/grid-column';
import { token } from '@atlaskit/tokens';

export const TabContainer = ({ children }: { children: ReactNode }): React.JSX.Element => {
	return (
		<Box xcss={styles.tabContainer}>
			<Grid layout="fluid">
				<GridColumn>{children}</GridColumn>
			</Grid>
		</Box>
	);
};

const styles = cssMap({
	tabContainer: {
		flex: '1 1 auto',
		position: 'relative',
		paddingTop: token('space.0'),
		paddingRight: token('space.300'),
		paddingBottom: token('space.0'),
		paddingLeft: token('space.300'),
		height: '100%',
	},
});
